// extracted by mini-css-extract-plugin
export default {"container":"styles_container__e-0dW","section":"styles_section__wO81-"};